import React, { useState, useContext, useRef } from "react";
import { Button, TextField } from "@mui/material";
import { GeneralContext } from "../../context/GeneralContext";
import { AuthContext } from "../../context/AuthContext";
import ConfirmationScreen from "../commonComponents/ConfirmationScreen";
// import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import "./adminComponents.scss";

function Package(props) {
  const {
    title,
    description,
    price,
    length,
    length_days = 0,
    active = false,
    expired = false,
    available = false,
    subscription = false,
    subscription_active = false,
    activeTill = "",
    admin = false,
    id,
    userPackageId,
    handleAdd,
    handlePurchaseInit,
    handleDeactivatePackage = () => {},
    handleModify = () => {},
    handleDeactivate = () => {},
    modifyRef = null,
    deactivateRef = null,
  } = props;
  const [days, setDays] = useState(0);
  const [months, setMonths] = useState(0);
  const [deactivateConfirmOpen, setDeactivateConfirmOpen] = useState(false);
  const deactivateButtonRef = useRef(null);
  const { recordedErrorLog } = useContext(GeneralContext);
  const { currentUser } = useContext(AuthContext);


  // DEBUG: Remove after troubleshooting

  const isWithinOneMonth = (dateString) => {
    try {
      const expirationDate = new Date(dateString + "T00:00:00Z");
      const today = new Date();
      const oneMonthFromNow = new Date();
      oneMonthFromNow.setMonth(today.getMonth() + 1);

      return expirationDate <= oneMonthFromNow;
    } catch (error) {
      recordedErrorLog("isWithinOneMonth function failure: ", error);
      return false;
    }
  };

  const isToday = (dateString) => {
    try {
      const today = new Date();
      const packageDate = new Date(dateString + "T00:00:00Z");

      return today.toDateString() === packageDate.toDateString();
    } catch (error) {
      recordedErrorLog("isWithinOneMonth function failure: ", error);
      return false;
    }
  };

  const handleDayChange = (e) => {
    try {
      const value = parseFloat(e.target.value);
      if (value < 0) {
        setDays(0);
      } else {
        setDays(value);
      }
    } catch (error) {
      recordedErrorLog("Day change handler has failed: ", error);
    }
  };

  const handleMonthChange = (e) => {
    try {
      const value = parseFloat(e.target.value);
      if (value < 0) {
        setMonths(0);
      } else {
        setMonths(value);
      }
    } catch (error) {
      recordedErrorLog("Month change handler has failed: ", error);
    }
  };

  const handleDeactivateClick = () => {
    setDeactivateConfirmOpen(true);
  };

  const handleConfirmDeactivate = () => {
    if (userPackageId != null) {
      handleDeactivatePackage(userPackageId);
    }
    setDeactivateConfirmOpen(false);
  };

  return (
    <div
      className="packageContainer"
      style={{ width: "100%", maxWidth: "500px" }}
    >
      <div className={`package ${expired ? "expired" : ""}`}>
        <div
          className={`packageTitle offer`}
          style={{ backgroundColor: "#e3f2fd", borderRadius: "8px 8px 0 0" }}
        >
          {/* <div className="titleAndQuest">
            <HelpOutlineIcon className="icon"/>
          </div> */}
          {title}
          {available &&
          ((!active &&
            (price < 1 ||
              (currentUser?.stripe_payment_allowed !== null &&
                currentUser?.stripe_payment_allowed === true))) ||
            (active &&
              !subscription_active &&
              price > 1 &&
              isToday(activeTill))) ? (
            <div
              className="activateButton"
              onClick={() => handlePurchaseInit(price, id)}
            >
              Activate
            </div>
          ) : active && subscription_active ? (
            <div
              className="activateButton"
              onClick={handleDeactivateClick}
              ref={deactivateButtonRef}
            >
              Deactivate
            </div>
          ) : (
            <></>
          )}
        </div>
        <div
          className="packageDetails"
          style={{
            whiteSpace: "pre-wrap",
            backgroundColor: "white",
            borderRadius: "0 0 8px 8px",
          }}
        >
          {description}
          <div className="moreSection">
            {/* <div className="moreButton" role="button">
              More
            </div> */}
          </div>
          {active ? (
            <div className={`timeLeft`} id="active-till-indicator">
              {subscription_active ? (
                "Automatic renewal scheduled before: "
              ) : (
                <span
                  style={{
                    color: isWithinOneMonth(activeTill) ? "#cc4444" : "inherit",
                  }}
                >
                  Expires on:
                </span>
              )}{" "}
              {activeTill}
            </div>
          ) : (
            <div className="offer" id="offer-container">
              {/* <div className="price">Cost: {price} CHF</div> */}
              {subscription ? (
                <div className="length">
                  <a href="mailto:contact@speqqle.com?subject=Access to Speqqle Basic">
                    Contact us
                  </a>{" "}
                  for an offer for longer access to Speqqle Basic!
                </div>
              ) : length_days > 0 ? (
                <div className="length">Duration: {length_days} Days</div>
              ) : (
                <div className="length">Duration: {length} Months</div>
              )}
            </div>
          )}
        </div>
        {admin ? (
          <div className="adminSection">
            <div className="note">ADMIN OPTIONS:</div>
            <div className="optionsSection">
              {active ? (
                // Admin controls for active packages (require userPackageId for modify/deactivate)
                <div className="option">
                  <Button
                    variant="contained"
                    className="addButton"
                    onClick={() => userPackageId != null && handleModify(userPackageId, days, months)}
                    style={{ marginRight: "10px" }}
                    ref={modifyRef}
                    disabled={userPackageId == null}
                  >
                    Modify
                  </Button>
                  <Button
                    variant="contained"
                    color="error"
                    className="addButton"
                    onClick={() => userPackageId != null && handleDeactivate(userPackageId)}
                    ref={deactivateRef}
                    disabled={userPackageId == null}
                  >
                    Deactivate
                  </Button>
                  <div className="dateSelection">
                    <div className="title">New Duration:</div>
                    <div className="days">
                      <TextField
                        label="Days"
                        value={days}
                        onChange={(e) => handleDayChange(e)}
                        className="timeInput"
                        size="small"
                        type="number"
                      />
                    </div>
                    <div className="monts">
                      <TextField
                        label="Months"
                        value={months}
                        onChange={handleMonthChange}
                        className="timeInput"
                        size="small"
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              ) : (
                // Admin controls for available packages
                <div className="option">
                  <Button
                    variant="contained"
                    className="addButton"
                    onClick={() => handleAdd(id, days, months)}
                  >
                    Add
                  </Button>
                  <div className="dateSelection">
                    <div className="title">Duration:</div>
                    <div className="days">
                      <TextField
                        label="Days"
                        value={days}
                        onChange={(e) => handleDayChange(e)}
                        className="timeInput"
                        size="small"
                        type="number"
                      />
                    </div>
                    <div className="monts">
                      <TextField
                        label="Months"
                        value={months}
                        onChange={handleMonthChange}
                        className="timeInput"
                        size="small"
                        type="number"
                      />
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
      {expired && available ? (
        <div className="renewSection">
          <div
            className="renewButton"
            onClick={() => handlePurchaseInit(price, id)}
            role="button"
          >
            Renew
          </div>
        </div>
      ) : (
        <></>
      )}
      <ConfirmationScreen
        onYes={handleConfirmDeactivate}
        onNo={() => setDeactivateConfirmOpen(false)}
        text="Deactivation stops any future automatic payment requests. The plan remains active but without automatic renewal. Are you sure you want to deactivate?"
        open={deactivateConfirmOpen}
        setOpen={setDeactivateConfirmOpen}
        element={deactivateButtonRef}
      />
    </div>
  );
}

export default Package;
